import { Controller } from '@hotwired/stimulus';

// Billables::ClientField: shows the client card once the selector has a client, and brings
// the selector back on Change, with the client's pill still selected: its X is what removes
// the client, and an outside click without a new choice just brings the card back.
export default class extends Controller {
  static targets = [
    'emptyInput',
    'selector',
    'card',
    'name',
    'email',
    'clientAddress',
    'clientPhone',
  ];
  static values = { clientId: String };

  #client = null;
  #searching = false;
  #savedContact = null;

  connect() {
    if (this.hasClientAddressTarget) {
      this.#savedContact = {
        address: this.clientAddressTarget.textContent,
        phone: this.clientPhoneTarget.textContent,
      };
    }
  }

  clientChanged(event) {
    this.#client = event.detail?.clients?.[0] ?? null;
    this.#searching = false;
    this.emptyInputTarget.disabled = this.#client !== null;

    if (this.#client) {
      this.nameTarget.textContent = this.#client.name || this.#client.email || '';
      this.#renderEmail();
      this.#renderClientContact();
    }
    this.element.toggleAttribute('data-selected', this.#client !== null);
  }

  // A purchase order's card shows the client's own address, which the selector does not
  // carry: another client's lines stay blank until the form is saved, the saved one's return.
  #renderClientContact() {
    if (!this.hasClientAddressTarget) {
      return;
    }
    const saved = this.#client.id === this.clientIdValue;
    this.clientAddressTarget.textContent = saved ? this.#savedContact.address : '';
    this.clientPhoneTarget.textContent = saved ? this.#savedContact.phone : '';
  }

  // The contact block is re-rendered by the server, which only knows the saved client.
  emailTargetConnected() {
    this.#renderEmail();
  }

  change() {
    this.#searching = true;
    this.element.removeAttribute('data-selected');

    const input = this.selectorTarget.querySelector(
      '[data-clients--client-selector-target="input"]'
    );
    // After the click has bubbled: the selector closes its dropdown on any click outside itself.
    setTimeout(() => input.focus());
  }

  #renderEmail() {
    if (this.#client && this.hasEmailTarget) {
      this.emailTarget.textContent = this.#client.email || '';
    }
  }

  clickedOutside(event) {
    if (!this.#searching || !this.#client || this.element.contains(event.target)) {
      return;
    }
    this.#searching = false;
    this.element.setAttribute('data-selected', '');
  }
}
